module.exports = __webpack_public_path__ + "components/weather-icon/static/dayheavyrain@3-8ff43051864c63e73f6538b854a60fe0.png";